import type { Locale } from './locales'
import en from './messages/en.json'
import ja from './messages/ja.json'
import ko from './messages/ko.json'

export type MessageValue = string | { [key: string]: MessageValue }
export type Messages = Record<string, MessageValue>
export type TranslationValues = Record<string, string | number>

// 번들 카탈로그 — git에 커밋되는 단일 진실 원천이자 GCS 로드 실패 시 폴백.
export const bundledMessages = {
  ko,
  en,
  ja,
} as const satisfies Record<Locale, Messages>

// 런타임 활성 카탈로그. 기본은 번들, GCS 팩 로드 시 applyLanguagePacks로 교체된다.
// ponytail: 모듈 전역 1개 — 카탈로그는 유저 무관 전역 데이터라 요청별 분리 불필요.
//           버전을 요청별로 갈라야 할 일이 생기면 그때 컨텍스트 주입으로 올린다.
let activeMessages: Record<Locale, Messages> = bundledMessages

/** GCS에서 받은 팩으로 활성 카탈로그를 교체. 누락된 로케일은 번들로 폴백한다. */
export const applyLanguagePacks = (packs: Partial<Record<Locale, Messages>>): void => {
  activeMessages = {
    ko: packs.ko ?? bundledMessages.ko,
    en: packs.en ?? bundledMessages.en,
    ja: packs.ja ?? bundledMessages.ja,
  }
}

const getMessage = (source: Messages, key: string): string | null => {
  const value = key.split('.').reduce<MessageValue | undefined>((current, segment) => {
    if (typeof current !== 'object' || current === null || Array.isArray(current)) {
      return undefined
    }
    return current[segment]
  }, source)

  return typeof value === 'string' ? value : null
}

const interpolate = (template: string, values?: TranslationValues) => {
  if (!values) {
    return template
  }

  return template.replace(/\{(\w+)\}/g, (match, key) => {
    const value = values[key]
    return value === undefined ? match : String(value)
  })
}

export const translate = (locale: Locale, key: string, values?: TranslationValues): string => {
  const template =
    getMessage(activeMessages[locale], key) ??
    getMessage(activeMessages.en, key) ??
    getMessage(bundledMessages[locale], key) ??
    getMessage(bundledMessages.en, key) ??
    key
  return interpolate(template, values)
}
